import { FEATURES, FEATURES_CMS, FEATURES_DEFAULTS, FEATURES_MARKETING, FEATURES_OPERATIONS, FEATURES_SALES, FEATURES_SERVICE } from './constants/RequestedDataTypes';
import { createRequestTypes } from './helpers/RequestActions';
export const FetchFeaturesRequestTypes = createRequestTypes(FEATURES);

// PER PRODUCT LINE REQUESTS
export const FetchFeaturesRequestTypesMARKETING = createRequestTypes(FEATURES_MARKETING);
export const FetchFeaturesRequestTypesSALES = createRequestTypes(FEATURES_SALES);
export const FetchFeaturesRequestTypesSERVICE = createRequestTypes(FEATURES_SERVICE);
export const FetchFeaturesRequestTypesOPERATIONS = createRequestTypes(FEATURES_OPERATIONS);
export const FetchFeaturesRequestTypesCMS = createRequestTypes(FEATURES_CMS);
export const FetchFeaturesWithDefaultsRequestTypes = createRequestTypes(FEATURES_DEFAULTS);